import { ApiBase } from '../ApiBase';
class SamplesBudgetApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getBalance = () => {
            return this.get('/samples-budget');
        };
        this.createCheckout = (payload) => {
            return this.post('/samples-budget/checkout', payload);
        };
        this.getReferralConfiguration = (params) => {
            return this.get('/samples-budget/referral-configuration/last-active', params);
        };
        this.getAffiliateReferrals = (params) => {
            return this.get('/samples-budget/affiliate-referrals', params);
        };
    }
}
export const SamplesBudgetApiClient = new SamplesBudgetApiClientModel();
